'use client';

import { useBooleanLocalStorageState } from 'src/utils/localStorageUtils';
import { singletonHook } from 'react-singleton-hook';

const useLayoutSplitSetting = () =>
	useBooleanLocalStorageState('splitLayout', false);

export default singletonHook([undefined, undefined], useLayoutSplitSetting);
